import { tv } from '~/utils/tv'

export const inputTextClearButtonContainerVariants = tv({
  base: 'input-text-clear-button',
  variants: {
    size: {
      md: '-mr-[6px]',
      ml: '-mr-[8px]',
      lg: '-mr-[8px]',
      xl: '-mr-[8px]',
    },
    readOnly: { true: 'invisible hidden' },
    disabled: { true: 'invisible hidden' },
    isActive: { true: 'invisible hidden' },
    filled: { false: 'invisible hidden' },
  },
  defaultVariants: {
    readOnly: false,
    disabled: false,
  },
})

export const inputTextClearButtonVariants = tv({
  base: '!px-none',
  variants: {
    size: {
      md: '!h-medium !w-medium',
      ml: '!h-mediumlarge !min-w-mediumlarge',
      lg: '!h-mediumlarge !min-w-mediumlarge',
      xl: '!h-mediumlarge !min-w-mediumlarge',
    },
  },
})
